import axios from 'axios'
import { store } from './vuex-store'
import { MUTATE_LOGOUT } from './vuex-store/types'

export const TOKEN_KEY = 'gosaas_token'

export default (subdomain) => {
  if (!subdomain) throw new Error("'subdomain' is required for GoSaaS API")

  const gosaasURL = new URL(process.env.GOSAAS_API_BASE_URL, window.location)
  const axiosOptions = {}

  if (process.env.NODE_ENV === 'development') {
    axiosOptions.headers = { 'X-DevServer-Subdomain': subdomain }
  } else {
    gosaasURL.hostname = subdomain + '.' + gosaasURL.hostname
  }

  axiosOptions.baseURL = gosaasURL.toString()

  const api = axios.create(axiosOptions)

  api.interceptors.request.use(interceptAuthHeader)
  api.interceptors.response.use(handleSucessResponse, handleFailureResponse)

  return api
}

const interceptAuthHeader = (req) => {
  req.headers['Authorization'] = `Bearer ${localStorage.getItem(TOKEN_KEY)}`

  return req
}
const handleSucessResponse = (res) => {
  if (res.data.error) {
    return Promise.reject(res.data)
  }

  return res
}
const handleFailureResponse = (err) => {
  if (err.response) {
    if (err.response.status === 401) {
      store.commit(MUTATE_LOGOUT)
    }
  }

  return Promise.reject(err)
}



// WEBPACK FOOTER //
// ./src/gosaas-api.js